<div *ngIf="checkViewMode('edit')" class="col-md-12">
  <a [href]="getPath(attribute.key)" target="_blank"><img src="../../../../../../assets/img/logo.png" width="100"></a>
  <button (click)="ngDelete(attribute.key)"><i class="fa fa-trash"></i></button>
  <div *ngFor="let item of attribute.attributes">
    <input [type]="item.type" [placeholder]="item.key" [(ngModel)]="item.value" class="form-control m-input" (blur)="onblur()">
  </div>
</div>

<div *ngIf="checkViewMode('view')" class="col-md-12">
    <a [href]="getPath(attribute.key)" target="_blank"><img src="../../../../../../assets/img/logo.png" width="100"></a>
  <div *ngFor="let item of attribute.attributes">
    <label *ngIf="item.key=='description'">{{item.value}}</label>
  </div>
</div>